import { render, staticRenderFns } from "./ImagenesProvider.vue?vue&type=template&id=0c32d504&"
import script from "./ImagenesProvider.vue?vue&type=script&lang=js&"
export * from "./ImagenesProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports